import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export default function FavoriteProducts() {
  const [favorites, setFavorites] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    checkUserAndFetch();
  }, []);

  async function checkUserAndFetch() {
    setLoading(true);
    const {
      data: { user: authUser },
    } = await supabase.auth.getUser();
    if (authUser) {
      setUser(authUser);
      await fetchFavorites(authUser.id);
    }
    setLoading(false);
  }

  async function fetchFavorites(userId: string) {
    try {
      const { data, error } = await supabase
        .from("user_favorites")
        .select(`product_id, products (*)`)
        .eq("user_id", userId);
      if (error) throw error;
      setFavorites(data || []);
    } catch (error) {
      console.error("Favoriler çekilemedi:", error);
    }
  }

  // --- YENİ: Favoriden Çıkarma Fonksiyonu ---
  const handleRemoveFavorite = async (productId: number) => {
    if (!user) return;

    // 1. Arayüzden anında sil (Hızlı tepki için)
    setFavorites((prev) =>
      prev.filter((item) => item.product_id !== productId),
    );

    // 2. Veritabanından sil
    const { error } = await supabase
      .from("user_favorites")
      .delete()
      .eq("user_id", user.id)
      .eq("product_id", productId);

    if (error) {
      console.error("Silme hatası:", error);
      // Hata olursa veriyi geri çek ki liste senkronize kalsın
      fetchFavorites(user.id);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <i className="ri-loader-4-line animate-spin text-3xl text-rose-500"></i>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen pb-20">
      {/* BAŞLIK ALANI */}
      <div className="bg-white border-b border-gray-100 mb-8">
        <div className="max-w-[1440px] mx-auto px-4 lg:px-8 py-10 pt-24">
          {" "}
          {/* Navbar altına girmemesi için pt-24 */}
          <div className="flex items-center gap-2 mb-2 text-sm">
            <Link to="/" className="text-gray-400 hover:text-rose-500">
              Ana Sayfa
            </Link>
            <i className="ri-arrow-right-s-line text-gray-300"></i>
            <span className="text-gray-900 font-medium">Favorilerim</span>
          </div>
          <h1 className="text-3xl font-black text-gray-900 uppercase tracking-tighter">
            Favorilerim{" "}
            <span className="text-rose-500">({favorites.length})</span>
          </h1>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-4 lg:px-8">
        {favorites.length === 0 ? (
          <div className="bg-white rounded-3xl p-16 text-center shadow-sm border border-gray-100">
            <i className="ri-heart-line text-6xl text-gray-200 mb-6 block"></i>
            <h3 className="text-xl font-bold text-gray-900">
              Favori listeniz boş
            </h3>
            <Link
              to="/"
              className="text-rose-600 font-bold mt-4 inline-block hover:underline"
            >
              Ürünleri Keşfet →
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
            {favorites.map((item) => (
              <div
                key={item.product_id}
                className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-lg transition-all group p-3 flex flex-col"
              >
                <div className="relative aspect-[3/4] mb-3 bg-gray-50 rounded-xl overflow-hidden">
                  <img
                    src={item.products?.image_url}
                    alt={item.products?.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                  />
                  {/* GÜNCELLENEN BUTON: onClick eklendi */}
                  <button
                    onClick={() => handleRemoveFavorite(item.product_id)}
                    className="absolute top-2 right-2 w-8 h-8 bg-white/90 hover:bg-white rounded-full flex items-center justify-center text-rose-500 shadow-sm transition-transform active:scale-90"
                    title="Favorilerden Kaldır"
                  >
                    <i className="ri-heart-fill text-lg"></i>
                  </button>
                </div>
                <div className="text-[10px] text-gray-400 font-bold uppercase truncate">
                  {item.products?.brand}
                </div>
                <h4 className="text-xs font-medium text-gray-800 mb-2 line-clamp-2 h-8">
                  {item.products?.name}
                </h4>
                <div className="mt-auto">
                  <div className="text-sm font-black text-gray-900">
                    {item.products?.current_price} ₺
                  </div>
                  <button
                    onClick={() =>
                      window.open(
                        item.products?.affiliate_link ||
                          item.products?.product_url,
                        "_blank",
                      )
                    }
                    className="w-full mt-2 py-2 bg-gray-50 text-[10px] font-bold rounded-lg border border-gray-200 hover:bg-rose-500 hover:text-white transition-colors"
                  >
                    MAĞAZAYA GİT
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
